import { cn } from "@/lib/utils";
import { PlaylistItemDTO } from "../../lib/types";

type Props = {
  item: PlaylistItemDTO;
  isFullScreen?: boolean;
};

export const DSPlayerLink: React.FC<Props> = ({ item, isFullScreen }) => {
  return (
    <iframe
      src={item.linkSrc}
      name="myiFrame"
      width="100%"
      height="100%"
      allowFullScreen
      className={cn("ds-player-link", isFullScreen && "with-full-screen")}
    ></iframe>
  );
};
